/**
 * Set SVG viewBox on hotspot-group SVGs to match their container size
 * so the coordinate system matches the layout.
 * @param {Document | Element} root - Root to search within (document or a section element)
 */
export function updateHotspotGroupViewBoxes(root) {
  const scope = root instanceof Document ? root : root;
  scope.querySelectorAll('svg.hotspot-group').forEach((svg) => {
    const parent = svg.parentElement;
    const rect = parent ? parent.getBoundingClientRect() : document.body.getBoundingClientRect();
    const width = Math.round(rect.width);
    const height = Math.round(rect.height);
    if (width > 0 && height > 0) {
      svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  updateHotspotGroupViewBoxes(document);
});
